export const today = new Date();
export const startDate = new Date("2019/12/06");
export const endDate = new Date("2020/01/06");
export const isBlackDecember = today >= startDate && today <= endDate;



// WEBPACK FOOTER //
// ./src/util/blackDecember.ts